import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

// Shared by carousels whose active slide grows wider (.grow-carousel, see components/carousel.css).
// Swiper re-measures slides, and snaps the track with no transition, whenever its element resizes
// or an image inside it loads. The growing slide does both mid-animation (taller card, lazysizes
// fetching a larger image), so: only react to real window resizes, drop the image-load update
// (slide widths come from CSS, not the images), and measure every slide at its resting width so
// the snap points stay evenly spaced. Space after the last slide (container minus one resting
// slide) lets every slide, including the last, stop flush at the left edge.
const startMeasuring = (swiper) => {
    swiper.el.classList.add('is-measuring')
    const slide = swiper.el.querySelector('.swiper-slide')
    swiper.params.slidesOffsetAfter = slide ? swiper.el.clientWidth - slide.offsetWidth : 0
}
const stopMeasuring = (swiper) =>
    requestAnimationFrame(() => swiper.el.classList.remove('is-measuring'))

const growCarousel = {
    speed: 500, // matches the slides' CSS width transition
    resizeObserver: false,
    on: {
        beforeInit: startMeasuring,
        init: (swiper) => {
            swiper.el.removeEventListener('load', swiper.onLoad, { capture: true })
            stopMeasuring(swiper)
        },
        beforeResize: startMeasuring,
        resize: stopMeasuring,
    },
}

new Swiper('.default-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 24,
    loop: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
            spaceBetween: 48,
        },
        1024: {
            slidesPerView: 2.25,
        },
        1280: {
            slidesPerView: 2.5,
            spaceBetween: 64,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
})

new Swiper('.image-carousel', {
    ...growCarousel,
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: false,
    centeredSlides: false,
    breakpoints: {
        1024: {
            spaceBetween: 24,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
})
document.querySelectorAll('.team-carousel').forEach((el) => {
    const handle = el.dataset.navHandle
    new Swiper(el, {
        ...growCarousel,
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        centeredSlides: false,
        breakpoints: {
            1024: {
                spaceBetween: 24,
            },
        },
        navigation: {
            prevEl: `.prev-${handle}`,
            nextEl: `.next-${handle}`,
        },
    })
})
new Swiper('.block-carousel', {
    ...growCarousel,
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: false,
    centeredSlides: false,
    breakpoints: {
        1024: {
            spaceBetween: 24,
        },
    },
    navigation: {
        prevEl: '.prev-block',
        nextEl: '.next-block',
    },
})
